"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { footballTrendClass } from "./FootballTrendUtils";

export default function FootballCorrectScoresSection({ title, correctScoresFull }) {
    const { home = [], draw = [], away = [] } = correctScoresFull || {};
    const allScores = [...home, ...draw, ...away];

    if (allScores.length === 0) return null;

    return (
        <div className="football-ods-detail-item ods-100 flex min-w-0 flex-col !bg-transparent !p-0">
            <div className="relative flex w-full flex-row gap-[10px]">
                <div className="text-white relative z-[1] cursor-default select-none rounded-t-[4px] bg-[var(--theme-live-chip-bg)] px-2 py-1 text-[12px] font-bold leading-tight">
                    {title}
                </div>
            </div>
            <div className="bg-[var(--theme-tab-inactive)] -mt-px rounded-b-[4px] rounded-tr-[4px] p-2.5">
                <div className="football-odstb-odds-list football-scores-grid">
                    {home.map((item, i) => (
                        <div key={`h${i}`}>
                            <div className="football-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                                {item.value2 !== undefined && (
                                    <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend2)}`}>
                                        {displayValue(item.value2)}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                    {draw.map((item, i) => (
                        <div key={`d${i}`}>
                            <div className="football-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                            </div>
                        </div>
                    ))}

                    {away.map((item, i) => (
                        <div key={`a${i}`}>
                            <div className="football-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                                {item.value2 !== undefined && (
                                    <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend2)}`}>
                                        {displayValue(item.value2)}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                    <div>
                        <div className="football-title-odds">AOS</div>
                        <div className="score-values">
                            <div className="odds ods-100 ods-white max-md:!text-[9px]">-</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

